<template>
  <div>
    <app-cells><h1 class="title">Payment control</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'PaymentControlLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'payment-control-groups', label: 'Next 2 weeks' },
        { name: 'payment-control-archive', label: 'Archive' },
      ],
    }
  },
}
</script>
